import useGoto from '~/hooks/use-goto';
import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import useSmartSendVersionFeature from '~/apps/profile/use-smartsend-version-feature';
import useOnLoad from '../use-on-load';

export default function Component() {
  const { goTo } = useGoto();
  const { revertPreferredSmartSendVersion } = useSmartSendVersionFeature();

  useOnLoad(() => {
    const work = async () => {
      if (localStorage.getItem(LocalStorageKeys.SmartSendSetup)) {
        localStorage.removeItem(LocalStorageKeys.SmartSendSetup);
      }
      await revertPreferredSmartSendVersion();
      goTo(RoutingConstants.SmartSend);
    };
    work();
  });

  return null;
}

Component.displayName = 'SmartSend';
